var map = {
	"./OiltankingLogisticaBrasil.jpg": 8327,
	"./OiltankingLogisticaBrasil_1.jpg": 39699,
	"./Oiltanking_South-America_Argentina_Puerto-Rosales_Tanks_2009-03-04_1070341.jpg": 69976,
	"./dji_0596_v3.jpg": 73507,
	"./dji_20250722152827_0001_v2.jpg": 14755,
	"./dji_20250904140448_0006_v1.jpg": 54009,
	"./gptw-latam-v2.jpg": 77502,
	"./image006.png": 72080,
	"./otamerica_esg_report_2024.jpg": 58946,
	"./suezmax.jpg": 77574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24899;